/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreditMemberStat {
  user_id: string | null;
  name: string;
  email: string | null;
  credits: number;
  entry_count: number;
  share: number;
}
